const isParentNavEnabled = false;
export default [
    {
        path: 'workstudy',
        name: 'workstudy',
        redirect : "home",
    },
    // {
    //     path: 'home',
    //     name: 'Home',
    //     //component: () => import( /* webpackChunkName: "workstudy-home" */ '../views/home.vue'),
    //     component: () => import( /* webpackChunkName: "workstudy-home" */ '../views/HomeSample.vue'),
    //     meta: {
    //         mainNavEnabled: isParentNavEnabled,
    //     },
    // },
    {
        path: 'home',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: 'users',
        name: 'Users',
        component: () => import('../views/Users.vue'),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: 'auditlogs',
        name: 'AuditLogs',
        component: () => import('../views/AuditLogs.vue'),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
]
